export enum ACTIONS {
  create = 'create',
  edit = 'edit',
  delete = 'delete',
  view = 'view'
}
